import { Component } from '@angular/core';
import { NavController,NavParams} from 'ionic-angular';
import { VerifyByPhoneFirstPage } from '../types/byphone/first/byphonefirst';
import { VerifyByQuestionPage } from '../types/byquestion/byquestion';
import { AppState } from '../../../../app/app.global';

@Component({
  selector: 'login-children-page',
  templateUrl: 'item.html'
})
export class RetrieveItemPage {
   item:any;
  constructor(public navCtrl: NavController,public navParm :NavParams,public global: AppState) {
  	this.item = navParm.get('item');
  }
  goRetrieveTypes(type){
    	if(type == "phone"){
    		this.navCtrl.push(VerifyByPhoneFirstPage, {});
    	}else if(type == "secrity"){
    		this.navCtrl.push(VerifyByQuestionPage, {});
    	}

  }

}



// WEBPACK FOOTER //
// ./src/pages/login/password/item/item.ts